import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.object.assign";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { set } from 'lodash';
export default {
  name: 'CoreDtwinStateEditTransformer',
  props: {
    // the current edited state
    lclModel: {
      type: Object,
      required: true
    },
    // is this an edit, create, or readonly?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    },
    // the original twin(/virtual-device)-model
    // to be used by some components for additional requesting data
    twinModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    // eslint-disable-next-line vue/require-prop-types
    aggregatedStateValue: {
      required: false,
      default: function _default() {
        return undefined;
      }
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    deviceTemplate: {
      type: Object,
      required: false,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      formIsValid: true,
      transformer: {
        template: null,
        templates: {
          simple: "module.exports = (data) => {\n  return data;\n}",
          wh_to_kwh: "module.exports = (data) => {\n  return data / 1000;\n}",
          c_to_f: "module.exports = (celsius) => {\n  return celsius * 9/5 + 32;\n}",
          f_to_c: "module.exports = (fahrenheit) => {\n  return (fahrenheit - 32) * 5/9;\n}",
          battery_v_to_p: "module.exports = (voltage) => {\n  // your milage may vary, this is just a linear approximation for high=100% and low=0%\n  // the actual battery-percentage is probably different\n  const high = 5.0; const low = 3.2;\n  return Math.min(100, ((voltage- low) / (high - low)) * 100);\n}",
          i_to_b: "module.exports = (data) => {\n  if (data == 0) {\n    return false;\n  }\n  return true;\n}",
          aggregate_first_value: "module.exports = (values) => {\n  const firstValue = values[Object.keys(values)[0]];\n  // states that have the same key are grouped\n  if (_.isArray(firstValue)) {\n    return firstValue[0].value\n  } else {\n\t  return firstValue.value\n  }\n}",
          aggregate_sum: "module.exports = (values) => {\n  let sum = 0;\n  Object.keys(values).forEach(key => {\n    const value = values[key];\n    // states that have the same key are grouped\n    if (_.isArray(value)) {\n      value.forEach(nestedValue => {\n        sum += _.get(nestedValue, 'value', nestedValue);\n      });\n    } else {\n      // or there is just one state with this key\n      sum += value.value;\n    }\n  });\n  return sum;\n}",
          aggregate_average: "module.exports = (values) => {\n  let sum = 0; let count = 0;\n  Object.keys(values).forEach(key => {\n    const value = values[key];\n    // states that have the same key are grouped\n    if (_.isArray(value)) {\n      value.forEach(nestedValue => {\n        sum += _.get(nestedValue, 'value', nestedValue);\n        count++;\n      });\n    } else {\n      // or there is just one state with this key\n      sum += value.value;\n      count++;\n    }\n  });\n  return sum / count;\n}",
          aggregate_max: "module.exports = (values) => {\n  let max = [];\n  Object.keys(values).forEach(key => {\n    const value = values[key];\n    // states that have the same key are grouped\n    if (_.isArray(value)) {\n      value.forEach(nestedValue => {\n        max.push(_.get(nestedValue, 'value', nestedValue));\n      });\n    } else {\n      // or there is just one state with this key\n      max.push(value.value);\n    }\n  });\n  return _.max(max);\n}",
          aggregate_min: "module.exports = (values) => {\n  let min = [];\n  Object.keys(values).forEach(key => {\n    const value = values[key];\n    // states that have the same key are grouped\n    if (_.isArray(value)) {\n      value.forEach(nestedValue => {\n        min.push(_.get(nestedValue, 'value', nestedValue));\n      });\n    } else {\n      // or there is just one state with this key\n      min.push(value.value);\n    }\n  });\n  return _.min(min);\n}",
          sum_day: "module.exports = (data, lastData) => {\n  // lastData = {value: 'X', time: '2020-13-37T42:99:00'} || undefined\n  // check that the last value is from the same day-in-month\n  const currentDate = new Date(new Date().toLocaleString('en-US', {timeZone: 'Europe/Berlin'}));\n  if (_.get(lastData, 'time') && currentDate.getDate() === new Date(lastData.time).getDate()) {\n    return data + (parseFloat(_.get(lastData, 'value')) || 0);\n  }\n  // otherwise start a new sum for today\n  return data;\n}",
          sum_month: "module.exports = (data, lastData) => {\n  const resetDay = 1; // reset value on every 1st of the month\n\n  // lastData = {value: 'X', time: '2020-13-37T42:99:00'} || undefined\n  if (_.get(lastData, 'time')) {\n  \tconst priorDay = new Date(_.get(lastData, 'time')).getDate();\n  \tconst currentDate = new Date(new Date().toLocaleString('en-US', {timeZone: 'Europe/Berlin'}));\n  \tif (priorDay > currentDate.getDate() || (priorDay < resetDay && currentDate.getDate() >= resetDay)) {\n    \t// the reset-day has passed since the last update, so start a new sum now\n    \treturn data;\n    }\n  }\n  return data + (parseFloat(_.get(lastData, 'value')) || 0);\n}",
          ignore_older_data: "module.exports = (data, lastData, meta) => {\n  // lastData = {value: 'X', time: '2020-13-37T42:99:00'} || undefined\n  if (_.get(lastData, 'time')) {\n  \tconst priorDataDate = new Date(_.get(lastData, 'time'));\n    if (priorDataDate.getTime() >= new Date(meta.timestamp).getTime()) {\n      throw new Error('Ignore older data');\n    }\n  }\n  return data;\n}"
        }
      },
      changedTransformer: false,
      transformerValidRule: [function () {
        return !_this.transformer.syntaxError || 'The transformer seems to be erroneous.';
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    bindingType: function bindingType() {
      return get(this.lclModel, 'properties.binding.type');
    },
    stateValue: function stateValue() {
      return get(this.lclModel, 'value.value');
    },
    stateValueType: function stateValueType() {
      return get(this.lclModel, 'properties.valueType');
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isCreatedByTemplate: function isCreatedByTemplate() {
      return !!this.deviceTemplate;
    },
    currentScript: function currentScript() {
      return get(this.lclModel, 'properties.binding.transformer.script');
    }
  }),
  created: function created() {
    if (!this.currentScript) {
      var clonedLclModel = cloneDeep(this.lclModel);
      clonedLclModel.properties.binding = Object.assign({}, this.lclModel.properties.binding, {
        transformer: {
          scriptId: null,
          // UUID
          scriptName: null,
          // UUID
          script: this.transformer.templates.simple
        }
      });
      this.$emit('update:lclModel', clonedLclModel);
    }
  },
  mounted: function mounted() {
    if (!this.templateContext && this.isCreatedByTemplate) {
      var currentStateKey = this.lclModel.key;
      var matchingTemplateStateDef = this.deviceTemplate.stateDefinition.find(function (sd) {
        return sd.key === currentStateKey;
      });
      var clonedLclModel = cloneDeep(this.lclModel);
      set(clonedLclModel, 'properties.binding.transformer.script', get(matchingTemplateStateDef, 'properties.binding.transformer.script', ''));
      this.$emit('update:lclModel', clonedLclModel);
    }
  },
  methods: {
    onScriptChange: function onScriptChange(newScript) {
      var clonedLclModel = cloneDeep(this.lclModel);
      set(clonedLclModel, 'properties.binding.transformer.script', newScript);
      this.$emit('update:lclModel', clonedLclModel);
    },
    validateForm: function validateForm() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.$refs.form) {
          _this2.formIsValid = _this2.$refs.form.validate();

          _this2.$emit('validatedTransformer');
        }
      });
    },
    refreshForm: function refreshForm() {
      var _this3 = this;

      setTimeout(function () {
        // required workaround to get the cursor appearing at the right spot
        // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
        _this3.$refs.codemirror.codemirror.refresh();

        _this3.$refs.codemirror.codemirror.focus();
      }, 50);
    },
    selectedTransformerTemplate: function selectedTransformerTemplate() {
      var clonedLclModel = cloneDeep(this.lclModel);
      set(clonedLclModel, 'properties.binding.transformer.script', this.transformer.templates[this.transformer.template]);
      this.$emit('update:lclModel', clonedLclModel);
    },
    saveState: function saveState() {
      if (get(this.lclModel.properties.binding.transformer, 'script')) {
        // ignore empty scripts, as those only lead to errors
        if (this.currentScript.trim() === '') {
          var clonedLclModel = cloneDeep(this.lclModel);
          set(clonedLclModel, 'properties.binding.transformer.script', null);
          this.$emit('update:lclModel', clonedLclModel);
        }
      }
    }
  }
};